import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { pageNames } from '@/enums/pageNames'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: pageNames.HOME,
      component: HomeView
    },
    {
      path: '/research',
      redirect: { name: pageNames.RESEARCH }
    },
    {
      path: '/research/editor',
      redirect: { name: pageNames.RESEARCH }
    },
    {
      path: '/research/editor/existing',
      redirect: { name: pageNames.RESEARCH }
    },
    {
      path: '/research/landing',
      name: pageNames.RESEARCH,
      component: () => import('../views/ResearchLandingView.vue')
    },
    {
      path: '/research/editor/new',
      name: pageNames.RESEARCHEDITORNEW,
      component: () => import('../views/NewResearchEditorView.vue')
    },
    {
      path: '/research/editor/existing/:id',
      name: pageNames.RESEARCHEDITOREXISTING,
      component: () => import('@/views/ResearchEditorView.vue')
    },
    {
      path: '/writer',
      name: pageNames.WRITER,
      component: () => import('@/views/WriterLandingView.vue')
    },
    {
      path: '/writer/editor/new',
      name: pageNames.WRITERNEWVIEW,
      component: () => import('@/views/NewWriterEditorView.vue')
    },
    {
      path: '/writer/editor/:id',
      name: pageNames.WRITEREDITORVIEW,
      component: () => import('@/views/WriterEditorView.vue')
    },
    {
      path: '/user',
      name: pageNames.USERPROFILE,
      component: () => import('@/views/UserProfileView.vue')
    },
    {
      path: '/signin',
      name: pageNames.LOGIN,
      component: () => import('@/views/auth/LoginView.vue')
    },
    {
      path: '/forgot-password',
      name: pageNames.FORGOTPASSWORD,
      component: () => import('@/views/auth/ForgotPasswordView.vue')
    },
    {
      path: '/reset-password',
      name: pageNames.RESETPASSWORD,
      component: () => import('@/views/auth/ResetPasswordView.vue')
    },
    {
      path: '/signout',
      name: pageNames.LOGOUT,
      component: () => import('@/views/LogoutView.vue')
    }
  ]
})

export default router
